// Radix dialogs listen for Escape on the document, so they hear it before a
// Base UI popup inside them can close itself. Base UI marks an open popup's
// trigger with `data-popup-open`, and the popup itself with `data-open` plus
// `data-side`. Collapsible and Accordion panels also carry `data-open`, but
// never `data-side`, so an open panel doesn't block Escape.
const OPEN_POPUP_SELECTOR = '[data-popup-open], [data-open][data-side]'

export function preventEscapeForOpenPopup(event: KeyboardEvent) {
  if (event.target instanceof Element && event.target.closest(OPEN_POPUP_SELECTOR)) event.preventDefault()
}
